/**
 * Utility functions for working with time ranges in the Activities page
 */

export interface TimeRange {
  start: Date;
  end: Date;
}

/**
 * Calculates a time range based on the selected filter
 */
export function getTimeRangeFromFilter(timeFilter: 'all' | 'today' | 'week' | 'month'): TimeRange | null {
  if (timeFilter === 'all') return null;
  
  const start = new Date();
  const end = new Date();
  
  switch (timeFilter) {
    case 'today':
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      break;
    case 'week':
      start.setDate(start.getDate() - start.getDay());
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      break;
    case 'month':
      start.setDate(1);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      break;
  }
  
  return { start, end };
}
